export default __webpack_public_path__ + "static/media/close-icon.670d59b7.svg";